export enum OrderOrderPaymentStatus {
	PAID = "PAID",
	CANCELED = "CANCELED",
}
